<template>
  <div class="user-message">
    <div class="titles-right">我的需求</div>
    <!-- 处理中和已反馈 -->
    <div>
      <div class="flex">
        <div class="tab-default c-pointer" :class="queryList.status==1?'tab-active':''" @click="queryList.status=1;loadDataList()">处理中</div>
        <div class="tab-default c-pointer" :class="queryList.status==2?'tab-active':''" @click="queryList.status=2;loadDataList()">已反馈</div>
      </div>
      <!-- 反馈列表 -->
        <div class="shadow pa-b-10 pa-r-10 ma-t-10 ma-r-20" v-for="(item,index) in commentList" :key="index">
          <div class="fon-18 flex f-center">
            <img :src="item.HeadImage" alt="" srcset="" class="head-img">
            {{item.InsertTime}}
          </div>
          <div class="comment-box">
           {{item.Content}}
            <div class="pa-10 c-000 b-f7f7f7 ma-t-10" v-if="item.DisposeRemark!=''">
              <div>
                {{item.DisposeTime}}
              </div>
              <span class="font-bold">需求反馈：</span>{{item.DisposeRemark}}
            </div>
          </div>
        </div>
        <div v-if="commentList.length==0">
            <div class="t-center ma-t-40">
              <img src="../img/empty.png" alt="" srcset="" width="200" />
              <div class="c-999">暂无数据</div>
            </div>
          </div>
        <div class="t-center ma-t-20">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="queryList.pageIndex"
          :page-size="queryList.pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getMytDatumList } from "../api";
export default {
  name: "Papers",
  props: {},
  data() {
    return {
      commentList:[],
      queryList:{
        pageIndex:1,
        pageSize: 10,
        status:1
      },
      totals: 0, //一个分类下的总条数
    };
  },
  created() {
    this.loadDataList()
  },
  mounted() {},
  // 其他页面进来时更新初始数据
  activated() {},
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e;
      this.loadDataList();
    },
    // 分享
    share(path, id) {
      console.log(path);
      console.log(id);
      let spath = path;
      let ids = id;
      let token = localStorage.getItem("AccessToken");
      let paths = `${spath}/shares.html?id=${ids}&token=${token}`;
      // console.log(paths)

      this.centerDialogVisible = true;
      this.$nextTick(() => {
        new QRCode(document.getElementById("qrCode"), {
          text: paths,
          width: 300,
          height: 300,
          colorDark: "#333333", //二维码颜色
          // colorLight: '#ffffff', //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      });
    },
    //分页查询
    loadDataList(){
      getMytDatumList(this.queryList).then(res=>{
        this.commentList=res.data.Data.List;
        this.totals=res.data.Data.TotalCount
      })
    }

  },
};
</script>

<style lang="scss">
.btn_green {
  width: 220px;
  height: 40px;
  background: #fb004d;
  border-radius: 20px;
  color: #fff;
}
.ma-tb-50 {
  margin: 50px auto;
}

.v-modal {
  z-index: 1997 !important;
}

#qrCode {
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    background-color: #fff; //设置白色背景色
    padding: 6px; // 利用padding的特性，挤出白边
  }

  .tets {
    width: 100%;
    text-align: center;
    color: #fff;
    margin-bottom: 5px;
  }
}

.user-message {
  width: 960px;

  background: #ffffff;
  padding-top: 16px;
  padding-bottom: 161px;
  padding-left: 56px;
  box-sizing: border-box;

  .chil {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }

  .titles-right {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 24px;
  }
  .btn-submit{
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-right: 40px;
  }
  

  .titles-right:before {
    content: "|";
    display: inline-block;
    width: 4px;
    height: 19px;
    background: #fb004d;
    color: #fb004d;
    border-radius: 2px;
    margin-right: 8px;
  }

  .papers {
    width: 240px;
    padding-bottom: 100px;
    margin-right: 25px;

    // text-align: center;
    img {
      width: 100%;
      height: 160px;
    }

    .title {
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      margin-top: 26px;
      margin-bottom: 10px;
    }

    .papers-detail {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 15px;
    }

    .btnss {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      div {
        width: 118px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        font-size: 14px;
        cursor: pointer;
      }

      .save {
        display: inline-block;
        background: #fb004d;
        color: rgba(255, 255, 255, 1);

        a {
          color: white;
          text-decoration: none;
        }
      }

      .share {
        border-radius: 20px;
        border: 1px solid#fb004d;
        color: #fb004d;
        margin-left: 19px;
      }
    }
  }
  .tab-default{
    margin-left: 20px;
    padding: 5px;
  }
  .tab-active{
    border-bottom: 2px solid #fb004d;
  }
  .head-img{
    width: 50px;
    height: 50px;
    margin: 10px;
    border-radius: 50%;
  }
  .comment-box{
    margin-left: 70px;
    color: #999;
  }
  .b-f7f7f7{
    background: #f7f7f7;
  }
}
</style>
